// 環境変数の取得（Vite環境変数を使用）
// Viteはビルド時にimport.meta.envを静的に置換します
// Production: CloudFront経由で同一ドメインのため空文字（相対パス）
// Development: localhost:3000（SAM Local）
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3000';
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
export const MICROSOFT_CLIENT_ID = import.meta.env.VITE_MICROSOFT_CLIENT_ID;
export const DFGATE_CLIENT_ID = import.meta.env.VITE_DFGATE_CLIENT_ID;
